var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传文件",
            visible: _vm.uploadFileVisible,
            width: "50%",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.uploadFileVisible = $event
            }
          }
        },
        [
          _c("ul", { staticClass: "upload_file_ul" }, [
            _c("li", { staticClass: "upload_file_li" }, [
              _c("h4", [_vm._v("原始文档")]),
              _c(
                "div",
                { staticClass: "upload_sign" },
                [
                  _vm.fileList.originFile
                    ? _c("div", [
                        _c("img", {
                          staticClass: "file_type_img",
                          attrs: {
                            src: _vm.fileTypeFn(_vm.fileList.originFile),
                            alt: ""
                          }
                        }),
                        _c("div", [
                          _vm._v(_vm._s(_vm.fileList.originFile.name))
                        ])
                      ])
                    : [
                        _c("div", { staticClass: "upload_icon_box" }, [
                          _c("i", { staticClass: "el-icon-upload icon_size" })
                        ]),
                        _c("div", { staticClass: "el-upload__text" }, [
                          _c("p", [
                            _c("em", [_vm._v("点击上传")]),
                            _vm._v(" 或拖拽文件上传")
                          ]),
                          _c("div", { staticClass: "tip_color" }, [
                            _vm._v(
                              "\n                支持doc、docx、pdf、xls、xlsx、.pptx、.ppt、.txt格式\n              "
                            )
                          ])
                        ])
                      ],
                  _c("input", {
                    staticClass: "input",
                    attrs: {
                      type: "file",
                      accept: ".doc,.docx,.pdf,.xls,.xlsx,.pptx,.ppt,.txt"
                    },
                    on: { change: _vm.originFileChangeFn }
                  })
                ],
                2
              )
            ]),
            _c("li", { staticClass: "upload_file_li" }, [
              _c("h4", [_vm._v("对比文档")]),
              _c(
                "div",
                { staticClass: "upload_sign" },
                [
                  _vm.fileList.targetFile
                    ? _c("div", [
                        _c("img", {
                          staticClass: "file_type_img",
                          attrs: {
                            src: _vm.fileTypeFn(_vm.fileList.targetFile),
                            alt: ""
                          }
                        }),
                        _c("div", [
                          _vm._v(_vm._s(_vm.fileList.targetFile.name))
                        ])
                      ])
                    : [
                        _c("div", { staticClass: "upload_icon_box" }, [
                          _c("i", { staticClass: "el-icon-upload icon_size" })
                        ]),
                        _c("div", { staticClass: "el-upload__text" }, [
                          _c("p", [
                            _c("em", [_vm._v("点击上传")]),
                            _vm._v(" 或拖拽文件上传")
                          ]),
                          _c("div", { staticClass: "tip_color" }, [
                            _vm._v(
                              "\n                支持doc、docx、pdf、xls、xlsx、.pptx、.ppt、.txt格式\n              "
                            )
                          ])
                        ])
                      ],
                  _c("input", {
                    staticClass: "input",
                    attrs: {
                      type: "file",
                      accept: ".doc,.docx,.pdf,.xls,.xlsx,.pptx,.ppt,.txt"
                    },
                    on: { change: _vm.targetFileChangeFn }
                  })
                ],
                2
              )
            ])
          ]),
          _c(
            "div",
            [
              _vm._v("\n      对比规则设置：\n      "),
              _c("el-checkbox", {
                attrs: { label: "忽略标点符号" },
                model: {
                  value: _vm.ignorePunctuations,
                  callback: function($$v) {
                    _vm.ignorePunctuations = $$v
                  },
                  expression: "ignorePunctuations"
                }
              })
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.uploadFileVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.comparisonLoading },
                  on: { click: _vm.contractComparisonFn }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.contractTypeVisible,
            width: "30%",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.contractTypeVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "contractTypeForm",
                  staticClass: "demo-contractTypeForm",
                  attrs: { model: _vm.contractTypeForm, rules: _vm.rules }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择合同类型：", prop: "region" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择合同类型" },
                          model: {
                            value: _vm.contractTypeForm.region,
                            callback: function($$v) {
                              _vm.$set(_vm.contractTypeForm, "region", $$v)
                            },
                            expression: "contractTypeForm.region"
                          }
                        },
                        _vm._l(_vm.templateContractTypeList, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.contractTypeVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.contractTypeSubmit }
                },
                [_vm._v("\n        确认\n      ")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.riskExaminationVisible,
            width: "35%",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.riskExaminationVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "riskForm",
                  staticClass: "demo-contractTypeForm",
                  attrs: { model: _vm.riskForm, rules: _vm.riskRules }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "合同领域：", prop: "categoryId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择合同领域" },
                          on: { change: _vm.categoryValChange },
                          model: {
                            value: _vm.riskForm.categoryId,
                            callback: function($$v) {
                              _vm.$set(_vm.riskForm, "categoryId", $$v)
                            },
                            expression: "riskForm.categoryId"
                          }
                        },
                        _vm._l(_vm.categoryList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "审核规则：", prop: "ruleId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择审核规则",
                            disabled: !_vm.riskForm.categoryId
                          },
                          model: {
                            value: _vm.riskForm.ruleId,
                            callback: function($$v) {
                              _vm.$set(_vm.riskForm, "ruleId", $$v)
                            },
                            expression: "riskForm.ruleId"
                          }
                        },
                        _vm._l(_vm.examinationRuleList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: Object.keys(item)[0],
                              value: Object.values(item)[0]
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "文件上传：", prop: "targetStoreId" } },
                    [
                      _c(
                        "div",
                        { staticClass: "upload_sign" },
                        [
                          _vm.riskForm.targetStoreId
                            ? _c("div", [
                                _c("img", {
                                  staticClass: "file_type_img",
                                  attrs: {
                                    src: _vm.fileTypeFn({
                                      name: _vm.riskForm.targetStoreId
                                    }),
                                    alt: ""
                                  }
                                }),
                                _c("div", [_vm._v(_vm._s(_vm.riskForm.name))])
                              ])
                            : [
                                _c("div", { staticClass: "upload_icon_box" }, [
                                  _c("i", {
                                    staticClass: "el-icon-upload icon_size"
                                  })
                                ]),
                                _c("div", { staticClass: "el-upload__text" }, [
                                  _c("p", [
                                    _c("em", [_vm._v("点击上传")]),
                                    _vm._v(" 或拖拽文件上传")
                                  ]),
                                  _c("div", { staticClass: "tip_color" }, [
                                    _vm._v("支持doc、docx格式")
                                  ])
                                ])
                              ],
                          _c("input", {
                            staticClass: "input",
                            attrs: { type: "file", accept: ".doc,.docx" },
                            on: { change: _vm.riskFileChangeFn }
                          })
                        ],
                        2
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.riskExaminationVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.riskLoading,
                    type: "primary",
                    size: "mini"
                  },
                  on: { click: _vm.riskExtractSubmitFn }
                },
                [_vm._v("\n        确认\n      ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35e00266", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35e00266","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/signInfo/examination-tool.vue
// module id = sDnu
// module chunks = 12 13 14 17 26